<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loadingVales"></loading>
    <b-row class="text-center mt-4">
      <b-col cols="1" md="3">
      </b-col>

      <b-col cols="9" md="6" >
        <b-row class="contenedorTablaSinColor" style="background:white ">
          <b-col cols="10" lg="11" class="pr-0">
            <b-input-group class="pl-3" >
              <b-form-input
                  class="input-filter"
                  maxLength="15"
                  v-model="valorInput"
                  type="search"
                  id="filterInput"
                  responsive
                  placeholder="Búsqueda por ID o nombre de vale"
                  @keydown.enter.native="buscarVales"
              >
              </b-form-input>
            </b-input-group>
          </b-col>
          <b-col cols="2" lg="1" class="pl-0">
            <b-button
                v-if="$localStorageService.can('Asignar_vales_busqueda')"
                class="mt-1"
                size="sm"
                variant="info"
                :disabled="loading"
                @click="buscarVales"
                responsive
            >
              <span v-if="!loading"
              >
                <em class="buscar_svg primary sm"></em>
              </span>
              <span v-else><b-spinner small></b-spinner></span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="1" class="text-left">
        <b-button
            v-if="$localStorageService.can('Asignar_vales_asignacion')"
            variant="primary"
            v-b-tooltip.hover
            title="Alta de Vales"
            class=" paddingbotones botonesAzulFuerte"
            @click="altaVales"
            responsive
        ><em class="vale_svg icon-boton"></em>
        </b-button>
      </b-col>


      <div class="col-12 mt-5 mr-0" style="min-height:60vh">
        <br>
        <b-row >
          <b-col cols="12" :md="mostrarBarraLateral ? 9 : 12">
            <div class="contenedorTablaSinColor" style="padding-left: 15px; padding-right: 15px;">
              <b-table
                    v-if="items.length > 0"
                    style="min-height: 35rem; max-height: 35rem"
                    small
                    :fields="fields"
                    :items="items"
                    :per-page="registrosPorPagina"
                    :current-page="currentPage"
                    responsive
                    thead-tr-class="columnasTablaSinColor"
                    caption-top>


                  <template v-slot:cell(Acciones)="row" style="width: 200px">
                    <b-button size="sm" variant="info" class="mr-1 mt-1 marginbotones "
                              v-if="$localStorageService.can('Asignar_vales_editar')"
                              v-b-tooltip.hover
                              title="Historial"
                              @click="activarBarraLateral(row.item.idVale, row.item.nombre, true)">
                      <em class="historial_svg sm icon-boton"></em>
                    </b-button>

                    <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones "
                              style="border-radius:15px"
                              v-if="$localStorageService.can('Asignar_vales_editar')"
                              v-b-tooltip.hover
                              title="Modificar herramienta"
                              @click="modificar(row.item)"
                    >
                      <em class="editar_svg sm"></em>
                    </b-button>

                    <b-button size="sm" variant="danger" class="mr-1 mt-1 marginbotones paddingbotones"
                              v-if="!row.item.registroActivo && $localStorageService.can('Asignar_vales_activar')"
                              v-b-tooltip.hover
                              title="Activar Vale"
                              @click="activarDesactivar(row.item)">
                      <em class="vale_desactivado_svg icon-boton"></em>
                    </b-button>
                    <b-button size="sm" variant="success" class="mr-1 mt-1 marginbotones paddingbotones"
                              v-else
                              v-b-tooltip.hover
                              title="Dar de baja"
                              @click="activarDesactivar(row.item)">
                      <em class="vale_svg icon-boton"></em>
                    </b-button>
                  </template>
                  <template v-slot:cell(saldo)="row">
                    {{ row.item.saldo | moneda }}
                  </template>
                  <template v-slot:cell(fechaAlta)="row">
                    {{ row.item.fechaAlta | formatoFechaCorta }}
                  </template>


                  <template v-slot:cell(nombre)="row">
                    <span v-b-popover.hover.topright="'Descripción: ' + row.item.descripcion"> {{row.item.nombre}} </span>
                  </template>

                  <template v-slot:cell(registroActivo)="row">
                    {{ row.item.registroActivo ? 'Activo':'Inactivo' }}
                  </template>

              </b-table>
              <div align="center" v-if="loading">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
              <div v-else>
                <b-alert class="mt-2" v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
              </div>
            </div>
            <b-pagination
                class="mt-2"
                align="center"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="registrosPorPagina"
            ></b-pagination>
          </b-col>
          <b-col cols="12" :md="mostrarBarraLateral ? 3 : 0" v-show="mostrarBarraLateral">
            <historial-corto ref="activarBarraLateralHistoria" @activarBarraLateral="activarBarraLateral(0, '', true)"/>
          </b-col>
        </b-row>
      </div>


    </b-row>



    <b-modal
        v-model="mostrarModalAlta"
        size="lg"

        class="redondeo"
        centered
        :no-close-on-backdrop="true"
        hide-footer>

      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class="icono vale_svg" style="filter: invert(18%) sepia(86%) saturate(1218%) hue-rotate(179deg) brightness(93%) contrast(90%); height: 30px"></em>
          <div class="headerTxt mLeft">{{titulo}}</div>
        </div>
      </template>

      <altaVales ref="modalModificar" v-if="mostrarModalAlta"
                 @cancelar="mostrarModalAlta=false"
                 :mostrarGuardar="mostrarGuardar"
                 :valeOriginal="valeSeleccionado"
                 @actualizar="buscarRegistroVales"/>

      <template #modal-footer="{ ok, cancel }">
        <div class="w-100 float-none text-center">
          <b-button
              class="mt-3 botonesAzulFuerte"
              variant="primary"
              style="margin:10px"
              @click="$refs.modalModificar.$refs.submitGuardar.click()">Guardar</b-button>

          <b-button
              class="mt-3 botonesGrisFuerte"
              style="margin:10px"
              @click="() => {mostrarModalAlta = false}">Cancelar
          </b-button>
        </div>
      </template>

    </b-modal>
  </div>
</template>

<script>

import {validationMixin} from "vuelidate";
import altaVales from "@/views/vales/altaVales.vue";
import HistorialCorto from "@/views/vales/historialCorto.vue";


export default {
  name: "listaValesNuevo",

  components: {
    HistorialCorto,
    altaVales,
  },

  mixins: [validationMixin],
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,
      loadingVales: false,

      fields: [
        {key: "idVale", label: "ID Vale", sortable: true},
        {key: "nombre", label: "Nombre del vale", sortable: true},
        {key: "plan", label: "Plan Asociado", sortable: true},
        {key: "fechaAlta", label: "Fecha de Creación ", sortable: true},
        {key: "usuarioModificacion", label: "Usuario que creó", sortable: true},
        {key: "saldo", label: "Saldo", sortable: true},
        {key: "registroActivo", label: "Estatus", sortable: true},
        "Acciones",
      ],

      currentPage: 1,
      items: [],
      registrosPorPagina:10,

      search: {
        etapaSearch: "",
        clasificacionSearch: "",
      },

      valorInput: '',
      filtro: {
        idVale: 0,
        nombre: ''
      },

      mostrarModalAlta: false,
      titulo: "",
      valeSeleccionado: {
        idVale: null,
        nombre: null,
        saldo: null,
        descripcion: null,
        idPlan: null
      },
      mostrarGuardar: false,
      filtroSeleccionado: 1,

      mostrarBarraLateral: false,

    };
  },
  mounted() {
    this.buscarVales();
  },

  methods: {
    altaVales() {
      this.mostrarModalAlta = true;
      this.titulo = "Crear nuevo vale";
      this.valeSeleccionado = {};
      this.mostrarGuardar = true;
    },
    buscarRegistroVales(filtro) {
      this.filtroSeleccionado = 1;
      this.valorInput = filtro.nombre;
      this.mostrarModalAlta = false;
      this.activarBarraLateral(filtro.idVale, filtro.nombre)
      this.buscarVales();
    },

    buscarVales() {
      this.currentPage = 1;
      this.loading = true;
      this.items = [];

      if (isNaN(this.valorInput)) {
        this.filtro.idVale = 0;
        this.filtro.nombre = this.valorInput;
      } else {
        this.filtro.idVale = Number(this.valorInput);
        this.filtro.nombre = '';
      }
      const params = {
        idVale: this.filtro.idVale,
        nombre: this.filtro.nombre
      }
      this.$http
          .post(this.$api + "vale/obtener", params)
          .then((response) => {
            this.items = response.data.data;
          }).finally(() => {
        this.loading = false;
      });
    },
    modificar(item) {
      this.valeSeleccionado = item;

      this.titulo = 'Editar vale';
      this.mostrarGuardar = false;
      this.mostrarModalAlta = true;
    },
    activarBarraLateral(idRegistro, nombreVale, mostrarHistorial) {
      if (mostrarHistorial) {
        this.$refs.activarBarraLateralHistoria.activarBarraLateral(idRegistro, nombreVale);
        if (!this.mostrarBarraLateral || idRegistro === 0) {
          this.mostrarBarraLateral = !this.mostrarBarraLateral;
        }
      }
    },

    activarDesactivar(item) {
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar el vale?':'¿Desea activar el vale?';

      this.$swal.fire({
        text: mensaje,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,

        preConfirm: () => {
          this.loading = true;
          const params = {
            idVale: item.idVale
          }
          this.$http
              .post(this.$api + "vale/activarInactivar", params  )
              .then((response) => {
                if (response.data.data) {
                  this.buscarVales();
                  this.activarBarraLateral(item.idVale, item.nombre);
                  this.$swal.fire({
                    position: "center",
                    icon: "success",
                    title: item.registroActivo ? "Se desactivó el vale":"Se activo el vale",
                    showConfirmButton: false,
                    timer: 3500,
                  });
                } else {
                  const params = {
                    idPlan: item.idPlan
                  }
                  this.$http.post(this.$api + "vale/existePlanConfig", params ).then(response => {
                    if (response.data.data) {
                       let planConfiguracion = response.data.data;

                      let tituloAlerta =  '<span class="mt-4" style="font-weight:600; font-size: 18px; color: var(--color-gris)">El plan seleccionado ya tiene un vale configurado</span><br>'
                      let text = '<span style="font-size: 14px"> El plan seleccionado ya tiene asignado el vale “'+ planConfiguracion.nombre +'” con el id “'+ planConfiguracion.idVale +'”. Desactiva ese vale para asignar otro.</span>'
                      this.$swal.fire({
                        icon: 'error',
                        html : tituloAlerta + text,
                        showCloseButton: false,
                        confirmButtonText: 'Enterado',
                        confirmButtonColor: '#595959',
                        customClass: {
                          confirmButton: 'rounded-pill',
                        },
                      })
                    }
                  }).catch((error) => {
                    console.error(error);
                  }).finally(() => {
                    this.loading = false;
                  });
                }
              });
        },
      });

    },

  },
  computed: {
    rows() {
      return this.items.length;
    },

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }


};
</script>

<style scoped>

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}

.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}
.icon-boton-agenda {
  filter: invert(18%) sepia(86%) saturate(1218%) hue-rotate(179deg) brightness(93%) contrast(90%);
  height: 20px;
  display: block;
}
.redondeo{
  border-radius: 10px !important;
}

.botonesGrisFuerte {
  border-radius: 10rem;
  color: #fff;
  margin-left: 5%;
}
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
.paddingbotones {
  padding: 5px;
}

.marginbotones{
  border-radius:20px;
}

.i
.bCardAgenda {
  margin: 0.5%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}




</style>
